import { ComponentProps } from 'react'

import { SegmentedControls as UISegmentedControls } from '@style-port/roov-ui-components-react'

type Props = ComponentProps<typeof UISegmentedControls>

export function SegmentedControls(props: Props) {
  return <UISegmentedControls {...props} />
}
